import { Component, OnInit } from "@angular/core";
import { LegislacionEntry } from "src/app/shared/entrys/legislacion.entry";
import { LegislacionService } from "./legislacion.service";

@Component({
  selector: "app-legislacion",
  templateUrl: "./legislacion.component.html",
  styleUrls: ["./legislacion.component.scss"],
})
export class LegislacionComponent implements OnInit {
  legislacion: Array<LegislacionEntry> = [];
  constructor(private legislacionService: LegislacionService) {}

  ngOnInit() {
    this.legislacionService.get(null).subscribe((resultado) => {
      if (resultado.result) {
        this.legislacion = resultado.data as Array<LegislacionEntry>;
      }
    });
  }

  onSaveFile(entry: LegislacionEntry) {
    window.open(entry.ruta_url);
  }
}
